import * as CollapsePrimitive from '@radix-ui/react-collapsible'
import React from 'react'
import { cn } from 'utils/cn'

const Collapse = CollapsePrimitive.Root

const CollapseTrigger = React.forwardRef<
	React.ElementRef<typeof CollapsePrimitive.CollapsibleTrigger>,
	React.ComponentPropsWithoutRef<typeof CollapsePrimitive.CollapsibleTrigger>
>(({ className, children, ...props }, ref) => (
	<CollapsePrimitive.CollapsibleTrigger
		ref={ref}
		className={cn(
			className,
			'type-body-medium flex shrink-0 cursor-pointer items-center justify-between gap-2 break-all text-left transition-all duration-200 [&>svg]:shrink-0',
		)}
		{...props}
	>
		{children}
	</CollapsePrimitive.CollapsibleTrigger>
))

CollapseTrigger.displayName = 'CollapseTrigger'

const CollapseContent = React.forwardRef<
	React.ElementRef<typeof CollapsePrimitive.CollapsibleContent>,
	React.ComponentPropsWithoutRef<typeof CollapsePrimitive.CollapsibleContent>
>(({ className, children, ...props }, ref) => (
	<CollapsePrimitive.CollapsibleContent
		ref={ref}
		className={cn(
			className,
			'type-body-medium overflow-hidden break-words will-change-transform data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down [&>svg]:shrink-0',
		)}
		style={{ transform: 'translateZ(0)' }}
		{...props}
	>
		{children}
	</CollapsePrimitive.CollapsibleContent>
))

CollapseContent.displayName = 'CollapseContent'

export { Collapse, CollapseContent, CollapseTrigger }
